import { useLogout } from "@/artifacts/auth/hooks/useLogout";
import { HStack } from "@/components/layout/HStack";
import { VStack } from "@/components/layout/VStack";
import { useAuth } from "@/context/authContext";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useTheme } from "@/hooks/useTheme";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu/DropdownMenu";
import { ChevronsUpDown, LogOut, MoonStar, Sun } from "lucide-react";
import styles from "./UserMenu.module.css";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/dashboard/Sidebar/Sidebar";

const UserMenu = () => {
  const isMobile = useIsMobile();
  const { state } = useAuth();
  const { theme, setTheme } = useTheme();
  const { logout } = useLogout();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton className={styles.trigger}>
              <HStack align="center">
                <div className={styles.avatar}>{state.user!.name.charAt(0)}</div>
                <VStack gap={0} align="flex-start">
                  <span className={styles.name}>{state.user!.name}</span>
                  <span className={styles.email}>{state.user!.email}</span>
                </VStack>
              </HStack>
              <ChevronsUpDown style={{ marginLeft: "auto" }} />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent side={isMobile ? "bottom" : "right"}>
            <DropdownMenuLabel>
              <HStack align="center">
                <div className={styles.avatar}>{state.user!.name.charAt(0)}</div>
                <VStack gap={0} align="flex-start">
                  <span className={styles.name}>{state.user!.name}</span>
                  <span className={styles.email}>{state.user!.email}</span>
                </VStack>
              </HStack>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem
                onClick={() =>
                  setTheme((prev) => (prev === "light" ? "dark" : "light"))
                }
              >
                {theme === "light" ? (
                  <>
                    <MoonStar />
                    Dark Mode
                  </>
                ) : (
                  <>
                    <Sun />
                    Light Mode
                  </>
                )}
              </DropdownMenuItem>
              <DropdownMenuItem onClick={logout}>
                <LogOut /> Log Out
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};

export { UserMenu };
